module.exports = __webpack_public_path__ + "static/img/p-16.4288c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-16.png
// module id = wZz1
// module chunks = 0